<template>
  <div>
    <b-container fluid>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />
      <b-card class="mb-1">
        <h5>Order Info</h5>

        <b-row>
          <b-col class="col-2">
            <strong>Client Name</strong>
          </b-col>
          <b-col v-if="order_obj.tracking_obj">{{
            order_obj.tracking_obj.client_name
            }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Channel</strong>
          </b-col>
          <b-col>{{ order_obj.channel }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Order #</strong>
          </b-col>
          <b-col>{{ order_obj.order_number }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Last Updated</strong>
          </b-col>
          <b-col>{{ order_obj.updated_at }}</b-col>
        </b-row>


      </b-card>

      <b-card class="mb-1">
        <b-form-group v-for="(canEditField, i) in canEditFields" :key="canEditField.key"
          :label="canEditField.label + ':'" :label-for="'txt_' + canEditField.key" label-size="sm">
          <!-- Channel: dropdown -->
          <b-form-select v-if="canEditField.key === 'channel'" :id="'txt_' + canEditField.key" :options="channelOptions"
            v-model="order_obj.channel" size="sm" />

          <!-- Pack by GOLS: checkbox -->
          <b-form-checkbox v-else-if="canEditField.key === 'pack_by_gols'" :id="'txt_' + canEditField.key"
            :checked="order_obj.pack_by_gols == 1" @change="order_obj.pack_by_gols = $event ? 1 : 0" switch size="sm">
            Yes
          </b-form-checkbox>

          <!-- Other fields: input -->
          <b-form-input v-else :id="'txt_' + canEditField.key" type="text" v-model="order_obj[canEditField.key]"
            size="sm" />
        </b-form-group>

        <!-- <b-button class="float-right" type="submit" variant="primary" @click="submitForm()">Submit</b-button> -->
      </b-card>

      <b-button class="mt-3 float-right" type="submit" variant="primary" @click="submitForm()">Submit</b-button>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

export default {
  name: "OrderMasterEdit",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      order_master_orders: [],
      canEditFields: [
        { key: "order_number", label: "Order #" },
        { key: "channel", label: "Channel" },
        { key: "pack_by_gols", label: "Pack by GOLS" }, // this will be a checkbox, handle it separately below
        { key: "customer_name", label: "Customer Name" },
        { key: "customer_address", label: "Customer Address" },
        { key: "customer_phone", label: "Customer Phone" },
        { key: "customer_email", label: "Customer Email" },
        { key: "order_date", label: "Order Date" },
        { key: "created_at", label: "Upload Date" },
        { key: "priority", label: "Priority" },
        { key: "remarks", label: "Remarks" },
        { key: "group_id", label: "Group ID" },
      ]
      ,
      breadcrumb_items: [
        {
          text: "Orders",
          to: { name: "orders" }
        },
        {
          text: "Edit",
          active: true
        }
      ],
      product: {},
      history_items: [],
      history_fields: [
        {
          key: "updated_at",
          label: "Updated at"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "pod_image",
          label: "POD"
        },
        {
          key: "updated_by",
          label: "Updated by"
        }
      ],
      loader: false,
      items: [],
      order_obj: {},
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_order_id: "",
      updating_item: false,
      search_criteria: {
        keyword: "",
        status_selected: null
      },
      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Pending",
          text: "Pending"
        },
        {
          value: "In-Transit",
          text: "In-Transit"
        },
        {
          value: "Returning to GOLS Warehouse",
          text: "Returning to GOLS Warehouse"
        },
        {
          value: "Successful Delivery",
          text: "Successful Delivery"
        },
        {
          value: "Returned to Warehouse",
          text: "Returned to Warehouse"
        }
      ],
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before"
        },
        {
          value: "on",
          text: "on"
        },
        {
          value: "after",
          text: "after"
        }
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",
      user_id: false,
      channelOptions: [],
      original_order_number: '',

    };
  },
  async created() {
    await this.getChannelOptions();
    await this.getOrderMaster();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    async getChannelOptions() {
      try {
        const response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "channel_get.php", // or your actual endpoint
          data: {
            client_id: this.$store.state.user_obj.client_id,
            user_id: this.$store.state.user_obj.user_id
          }
        });

        this.channelOptions = response.data.channels.map(c => ({
          value: c.name,
          text: c.name
        }));

      } catch (err) {
        console.error("Failed to fetch channel options:", err);
      }
    },
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getOrderMaster() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_get.php",
        data: {
          order_master_id: this.$route.params.id,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.order_obj = response.data.orders[0];
      this.original_order_number = this.order_obj.order_number;


      this.loader.hide();
    },

    showModal_reschedule_product(item) {
      this.updating_item = item;
      this.reschedule_type_selected = "before";
      this.reschedule_date = moment().format("YYYY-MM-DD");
      this.$refs.modal_reschedule_product.show();
    },

    hideModal_reschedule_product() {
      this.$refs.modal_reschedule_product.hide();
    },

    async submitForm() {
      const newOrderNumber = this.order_obj.order_number ? this.order_obj.order_number.trim() : '';

      if (!newOrderNumber) {
        this.$bvModal.msgBoxOk("Order # cannot be empty.", {
          title: "Validation Error",
          size: "lg",
          okVariant: "danger",
          centered: true,
        });
        return;
      }

      // If changed, prompt for confirmation
      if (newOrderNumber !== this.original_order_number) {
        const confirmed = await this.$bvModal.msgBoxConfirm(
          `You have changed the Order # from "${this.original_order_number}" to "${newOrderNumber}"`,
          {
            title: "Confirm Order # Change",
            size: "lg",
            okVariant: "danger",
            okTitle: "Yes",
            cancelTitle: "No",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        );

        if (!confirmed) return;
      }

      this.updateOrder();
    },


    async updateOrder() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_edit.php",
        data: {
          order_obj: this.order_obj,
          user_id: this.$store.state.user_obj.user_id,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      this.loader.hide();

      if (response.data.status === "success") {
        this.$eventHub.$emit("show_modal_message", {
          message_content: `Order Update Successfully.`
        });
        this.getOrderMaster();
      } else {
        // Show error message
        this.$bvModal.msgBoxOk(response.data.error || "Failed to update order.", {
          title: "Update Failed",
          size: "lg",
          okVariant: "danger",
          centered: true,
        });
      }
    },
    async getOrderMasterProduct() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_product_get.php",
        data: {
          order_number: this.product.order_number,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      this.order_master_orders = response.data.orders;

      this.loader.hide();
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderMasterEdit.vue